<table class="table table--full-width">
  <thead>
    <tr>
      <th>Calculated Field</th>
      <th>Reading</th>
    </tr>
  </thead>
  <tbody>
      <tr *ngFor="let field of fields">
        <td>{{field.Name}}</td>
        <td>{{field.Reading < 0 ? 'Error: Reading is missing or is a negative number. ' : field.Reading}}</td>
      </tr>
  </tbody>
</table>
